import { render, staticRenderFns } from "./AddOrEditHubsByForm.vue?vue&type=template&id=593712fa"
import script from "./AddOrEditHubsByForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditHubsByForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports